export const apiListPackages = '/1.0/wsm/package/list';
export const apiPackageDetail = (id) => `/1.0/wsm/package/${id}/detail`
export const apiPackageCreate = '/1.0/wsm/package/create';
export const apiPackageUpdate = id => `/1.0/wsm/package/${id}/update`;
export const apiPackageDelete = `/1.0/wsm/package/delete`;

// Leader
export const apiListPackagesLeader = '/1.0/wsm/leader/package/list';
export const apiPackageDetailLeader = (id) => `/1.0/wsm/leader/package/${id}/detail`
export const apiBuyPackageLeader = '/1.0/wsm/sim/package/create';